
export const preflight = async (data) => {
  const { data: response } = await window.axios.post(`${window.baseUrl}/car/preflight`, data)

  return response
}

export const saveCar = async (data) => {
  const { data: response } = await window.axios.post(`${window.baseUrl}/car/save`, data)

  return response
}

export const getExchangeCarsForCarId = async (carId) => {
  const { data: response } = await window.axios.post(`${window.baseUrl}/car/searchCars`, {
    query: {
      type: 'CONJUNCTION',
      conditions: [
        {
          value: carId,
          type: 'EQUALS',
          field: 'item_exchange_of'
        }
      ]
    },
    fields: [
      'id',
      'item_fin',
      'item_shared_title',
      'status.title'
    ]
  })

  return response
}

export const searchCar = async (data) => {
  const { data: response } = await window.axios.post(`${window.baseUrl}/car/searchCars`, data)

  return response
}

export const exchangeCarAdd = async (data) => {
  const { data: response } = await window.axios.post(`${window.baseUrl}/car/exchangeCarAdd`, data)

  return response
}

export const exchangeCarRemoval = async (data) => {
  const { data: response } = await window.axios.post(`${window.baseUrl}/car/exchangeCarRemoval`, data)

  return response
}

export const addProvisionItems = async (data) => {
  const { data: response } = await window.axios.post(`${window.baseUrl}/provisions/addProvisionItems`, data)

  return response
}

export const updateProvisionItems = async (data) => {
  const { data: response } = await window.axios.post(`${window.baseUrl}/provisions/updateProvisionItems`, data)

  return response
}

export const getCar = async (data) => {
  const { data: response } = await window.axios.post(`${window.baseUrl}/car/get`, data)

  return response
}

export const getCarDamage = async (carId) => {
  const { data: response } = await window.axios.get(`${window.baseUrl}/car/damage/${carId}`)

  return response
}

export default {
  preflight,
  saveCar,
  getExchangeCarsForCarId,
  searchCar,
  exchangeCarAdd,
  exchangeCarRemoval,
  addProvisionItems,
  updateProvisionItems,
  getCar
}
